import React from 'react';
import PropTypes from 'prop-types';

import DealField from 'bundles/apex/deals/form/fields/field';
import DefaultGrossCommission from './default';
import LeaseDealGrossCommission from './lease';

export function GrossCommission({ deal, ...props }) {
  if (deal.dealType === 'lease' || deal.dealType === 'tenant_rep') {
    return <LeaseDealGrossCommission deal={deal} {...props} />;
  } else {
    return <DefaultGrossCommission deal={deal} {...props} />;
  }
}

GrossCommission.propTypes = {
  deal: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
  }).isRequired,
};

export default DealField(GrossCommission, 'grossCommission');
